import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import Keycloak from 'keycloak-js';
import { Observable, defer, finalize, from, map, of, switchMap, take } from 'rxjs';
import { TaskService } from 'src/app/layout/topbar/components/tasks-sidebar/services/task.service';
import { environment } from 'src/environments/environment';
import { RgsKeycloakProfile } from '../models/rgs-keycloak-profile.model';
import { PermissionsService } from './permissions.service';

@Injectable({
  providedIn: 'root',
})
export class LicenseSwitchService {
  private readonly http = inject(HttpClient);
  private readonly permissionsService = inject(PermissionsService);
  private readonly taskService = inject(TaskService);
  private readonly keycloak = inject(Keycloak);

  public readonly apiUrl = environment.springAppUrl;

  public readonly switching = signal(false);

  public switchTo(license: string): Observable<void> {
    if (license === this.permissionsService.license) {
      return of(undefined);
    }

    return defer(() => {
      this.switching.set(true);
      return this.http.post<void>(`${this.apiUrl}/licensecontroller/set-current/${license}`, {});
    }).pipe(
      take(1),
      switchMap(() => {
        window.sessionStorage.setItem('environment', license);
        this.taskService.unloadItems();
        this.permissionsService.license$.next(license);

        const profile = this.keycloak.profile as RgsKeycloakProfile | undefined;
        const userId = this.permissionsService.userProfile()?.id ?? profile?.id;

        if (!userId) {
          console.error('Keycloak profile is not available or does not contain an ID.');
          return of(undefined);
        }

        return from(this.permissionsService.loadUser(userId));
      }),
      map(() => undefined),
      finalize(() => this.switching.set(false)),
    );
  }
}
